import Promise from 'bluebird';

import axios from 'axios';
import isURL from 'validator/lib/isURL';
import api from '../configs/configs.api';
import AuthService from './AuthService';

window.Promise = Promise;

axios.interceptors.request.use(config => {
  const newConfig = { ...config };
  if (newConfig.url && !isURL(newConfig.url)) {
    newConfig.url = `${api.url}${newConfig.url}`;
  }
  if (AuthService.isAuthenticated) {
    newConfig.headers.Authorization = `Bearer ${AuthService.token}`;
  }
  return newConfig;
});

axios.interceptors.response.use(undefined, error => {
  const originalRequest = error.config;
  if (
    error.response &&
    error.response.status === 401 &&
    originalRequest
    // !originalRequest._retry &&
    // !originalRequest.__isRetryRequest
  ) {
    AuthService.logout();
    // Refresh token handler
    // originalRequest._retry = true;
    // originalRequest.__isRetryRequest = true;
    // return AuthService.refreshToken()
    //   .then(({ data }) => {
    // new header new token
    // originalRequest.headers.Authorization = `Bearer ${AuthService.token}`;
    //     return axios(originalRequest);
    //   })
    //   .catch((err) => {
    //     AuthService.logout();
    //     return err;
    //   });
  }
  return Promise.reject(error);
});

export default axios;



// WEBPACK FOOTER //
// ./src/services/HttpService.js